import { z } from 'zod/v4';

const errorInputSchema = z.record(z.string(), z.unknown());

export const httpErrorDetailSchema = z.object({
  ctx: z.record(z.string(), z.unknown()).optional(),
  input: z.string().or(errorInputSchema).optional(),
  loc: z.array(z.union([z.string(), z.number()])),
  msg: z.string(),
  type: z.string(),
});

export type HttpErrorDetail = z.infer<typeof httpErrorDetailSchema>;

export const httpErrorDetailsSchema = z.array(httpErrorDetailSchema);
